module.exports = __webpack_public_path__ + "img/ArgonMedicalDevices.10b0bdd1.jpg";